import { getToken, setToken, removeToken, getUserInfo } from "@/utils/tokenManager"
import { login, getCurPri } from "@/api/user"
import { launchConnect, disconnect } from "@/utils/socket"
import { initUserData } from "@/utils/user"
import { initLocation } from "@/utils/location"
import { refreshTheme } from "../actions"

const LAST_WORK_SHEET_PATH_KEY = "LAST_WORK_SHEET_PATH_KEY"
let lastWorkSheetPath
try {
  lastWorkSheetPath = JSON.parse(localStorage.getItem(LAST_WORK_SHEET_PATH_KEY))
} catch (e) {
  lastWorkSheetPath = null
}

const share = window.location.pathname.includes("board/share")
  ? window.location.pathname.split("/")[3]
  : null

const state = {
  token: getToken(share),
  userInfo: {},
  userPermission: {},
  lastWorkSheetPath: lastWorkSheetPath,
  unreadMessageCount: 0,
  location: null, // 当前定位
  mode: "common", // 当前状态 template:模板预览 common:普通
  theme: "standard" // "standard","simple"
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_PERMISSION: (state, userPermission) => {
    state.userPermission = userPermission
  },
  RESET_STATE: state => {
    Object.assign(state, {
      userInfo: {},
      userPermission: {},
      token: ""
    })
  },
  SET_LAST_WORK_SHEET_PATH(state, workSheetPath) {
    state.lastWorkSheetPath = workSheetPath
  },
  SET_UNREAD_MESSAGE_COUNT: (state, count) => {
    state.unreadMessageCount = count
  },
  SET_MODE: (state, mode) => {
    state.mode = mode
  },
  SET_LOCATION: (state, location) => {
    state.location = location
  },
  SET_THEME: (state, theme) => (state.theme = theme)
}

const actions = {
  login(context, userInfo) {
    const { username, password } = userInfo
    return login(username, password)
  },
  setToken({ commit }, { token, share }) {
    if (!token) return Promise.resolve()
    return new Promise((resolve, reject) => {
      let userInfo = getUserInfo(token)
      if (!userInfo) {
        commit("RESET_STATE")
        resolve()
      }
      commit("SET_TOKEN", token)
      commit("SET_INFO", userInfo)
      setToken(token, share) // 设置 Cookie - token
      setTimeout(() => {
        // 提前请求，加快加载速度
        initUserData()
        initLocation()
      }, 2000)
      if (!share) launchConnect() // 连接 websocket
      refreshTheme()
      // 获取当前用户权限
      getCurPri()
        .then(pri => commit("SET_PERMISSION", pri))
        .finally(() => resolve())
    })
  },
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      removeToken(share) // 移除 Cookie - token
      // disconnect() // 断开 websocket
      // commit("RESET_STATE")
      resolve()
    })
  },
  setLastWorkSheetPath({ commit }, routeParams) {
    let { appId, sheetId, viewId } = routeParams
    if (!appId || !sheetId || !viewId) return Promise.reject("workSheetPath不合法")
    localStorage.setItem(LAST_WORK_SHEET_PATH_KEY, JSON.stringify(routeParams))
    commit("SET_LAST_WORK_SHEET_PATH", routeParams)
    return Promise.resolve()
  },
  setUnreadMessageCount({ commit }, count) {
    commit("SET_UNREAD_MESSAGE_COUNT", count)
    return Promise.resolve()
  },
  setMode({ commit }, mode) {
    commit("SET_MODE", mode)
  },
  setLocation({ commit }, location) {
    commit("SET_LOCATION", location)
  },
  setTheme({ commit }, theme) {
    commit("SET_THEME", theme)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
